import { render } from "./Ad1.vue?vue&type=template&id=3fe8b7ea&scoped=true"
import script from "./Ad1.vue?vue&type=script&lang=js"
export * from "./Ad1.vue?vue&type=script&lang=js"

import "./Ad1.vue?vue&type=style&index=0&id=3fe8b7ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe8b7ea"]])

export default __exports__